import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_organisation/organisation/exports")({
  component: Outlet,
});
